import { atom, selector, selectorFamily } from 'recoil'
import { IAccount } from '../types/types'
import { api } from '../utils/api'

const fetchAccounts = async (): Promise<IAccount[]> => {
  const { data } = await api.get('/accounts')
  return data.accounts
}

export const accountsState = atom<IAccount[]>({
  key: 'accountsState',
  default: selector({
    key: 'accountsState/Default',
    get: async (): Promise<IAccount[]> => fetchAccounts(),
  }),
})

export const accountState = selectorFamily<IAccount | null, string>({
  key: 'accountState',
  get:
    (id: string) =>
    async ({ get }) => {
      return get(accountsState).find((item) => item.id === id) || null
    },
})